import Settings 	from './CanvasSettings';
import _ 	from 'lodash';

class Utils {

    /**
     * Calculate the coordinates of a mouse event
     * @deprecated
     */
    coords(event) {
        const rect = event.currentTarget.getBoundingClientRect();
        // const rect = {left: event.currentTarget.offsetLeft, top: event.currentTarget.offsetTop };
        // console.log(event);
		const coords = {
			left: event.clientX - rect.left,
			top:  event.clientY - rect.top
		};
        return coords;
    }

    /**
     * Return the scale that is applied to an element
     */
    scale(elem) {
        return elem.getBoundingClientRect().width / elem.offsetWidth;
    }
    
    coordsRelative(target, parent) {
        const targetRect = target.getBoundingClientRect();
		const canvasRect = parent.getBoundingClientRect();

        const scale = 1 / this.scale(parent);

		const rect = {
			left:   scale * (targetRect.left - canvasRect.left),
			top:    scale * (targetRect.top  - canvasRect.top),
			width:  scale * (targetRect.width),
			height: scale * (targetRect.height)
		};

        return rect;
    }

    getOccupiedCells(element) {
        const size = element.size || Settings.defaultSize;
        // const size = element.size || Settings.defaultSize;
        var shape = element.shape || Settings.defaultShape;

       

		// const space = element.space ? element.space : [size, size];
		// const spaceCols = space[0];
		// const spaceRows = space[1];

		// for (let row = element.row; row >= element.row - spaceRows; row--) {
		// 	for (let col = element.col; col >= element.col - spaceCols; col--) {

		// He puesto el (size - 1) para que no tenga en cuenta los tres bloques

        const cells = [];
		for (let row = element.row; row > element.row - (size * shape[0]); row--) {
			for (let col = element.col; col > element.col - (size * shape[1]); col--) {
                cells.push([row, col]);
            }
        }

        return cells;

    }
    

}

let obj = new Utils();

export default obj;


// WEBPACK FOOTER //
// ./src/Utils.js